// Queue a microtask that will run at the end of the current event. The tasks
// are uniqued by name.
//
// This is helpful to consolidate the same action that may be triggered multiple
// times by unrelated code. This is especially likely with smart guides which
// snap the object position after it has already been moved.

type Func = () => void;

let queue: Record<string, Func> = {};
let processingQueue = false;

/** @deprecated don't use this, fix the root cause of the duplication instead */
function oncePerEvent(
  name: string,
  withoutBatching: boolean,
  func: Func
): void {
  if (processingQueue || withoutBatching) {
    func();
    return;
  }

  // If this is the first queued function, create the microtask that will
  // run after the current event.
  if (Object.keys(queue).length === 0) {
    queueMicrotask(() => {
      const oldQueue = queue;
      // Reset first, since we may enqueue more functions while executing the
      // current queue.
      queue = {};

      // Run the queued tasks.
      processingQueue = true;
      try {
        Object.values(oldQueue).forEach(func => {
          func();
        });
      } finally {
        processingQueue = false;
      }
    });
  }
  queue[name] = func;
}

export { oncePerEvent };
